import React from 'react';
import { MessageSquare as LucideMessageSquare } from 'lucide-react';

interface MessageSquareProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const MessageSquare: React.FC<MessageSquareProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideMessageSquare
    width={width}
    height={height}
    className={className}
    style={style}
    aria-hidden
    strokeWidth={1.5}
  />
);

export default MessageSquare;
